import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CountdownModule } from 'ngx-countdown';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../pipes/pipes.module';
import { AssessmentCategoriesComponent } from './assessment-categories/assessment-categories.component';
import { AssessmentInfoCardComponent } from './assessment-info-card/assessment-info-card.component';
import { CandidateHeaderComponent } from './candidate-header/candidate-header.component';
import { CandidateWelcomeComponent } from './candidate-welcome/candidate-welcome.component';
import { CandidateComponent } from './candidate.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { PendingAssessmentsComponent } from './pending-assessments/pending-assessments.component';
import { HighlightCodeModule } from './pipes/highlight-code/highlight-code.module';
import { QuestionViewComponent } from './question-view/question-view.component';
import { SubmittedViewComponent } from './submitted-view/submitted-view.component';
import { CodingQuestionViewComponent } from './coding-question-view/coding-question-view.component';
import { BlockCopyPasteDirective } from './block-copy-paste.directive';
import { AssessmentExpireComponent } from './assessment-expire/assessment-expire.component';
import { NotInterestedComponent } from './not-interested/not-interested.component';

const routes: Routes = [
  {
    path: '',
    component: CandidateComponent
  },
  {
    path: 'candidate-welcome/:id',
    component: CandidateWelcomeComponent
  },
  {
    path: 'assessment-categories',
    component: AssessmentCategoriesComponent
  },
  {
    path: 'exam-question-view',
    component: QuestionViewComponent
  },
  {
    path: 'submitted',
    component: SubmittedViewComponent
  },
  {
    path: 'expiredAssessment',
    component: AssessmentExpireComponent
  },
  {
    path: 'pendingAssessments',
    component: PendingAssessmentsComponent
  },
  {
    path: 'change-password',
    component: ConfirmPasswordComponent
  },
  {
    path: 'not-interested',
    component: NotInterestedComponent
  }
];

@NgModule({
  declarations: [
    CandidateComponent,
    CandidateWelcomeComponent,
    QuestionViewComponent,
    SubmittedViewComponent,
    PendingAssessmentsComponent,
    ConfirmPasswordComponent,
    CandidateHeaderComponent,
    AssessmentCategoriesComponent,
    AssessmentInfoCardComponent,
    CodingQuestionViewComponent,
    BlockCopyPasteDirective,
    AssessmentExpireComponent,
    NotInterestedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CountdownModule,
    HighlightCodeModule,
    PipesModule,
    RouterModule.forChild(routes)
  ],
  exports: []
})

export class CandidateModule { }
